import React from "react";
import "./Social.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLinkedin, faGithub, faFacebook, faInstagram,
} from "@fortawesome/free-brands-svg-icons";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { useLanguage } from "./LanguageContext";
import SandRevealImg from "./SandRevealImg";

const Social = () => {
  const { t } = useLanguage();

  const scrollDown = () => {
    window.scrollBy({ top: window.innerHeight * 0.85, behavior: "smooth" });
  };

  return (
    <section className="hero-section">

      {/* Avatar — sand-grain reveal on page load */}
      <div className="hero-avatar-wrap">
        <SandRevealImg
          src="myphoto.svg"
          alt="Avatar"
          imgClassName="hero-avatar"
          size={300}
          triggerOnMount   /* start immediately, not on scroll */
        />
        <div className="hero-avatar-ring" />
      </div>

      {/* Name */}
      <h1 className="hero-name hero-anim hero-anim--1">
        Abdul Wahhab Alfaghiri Al Anzi
      </h1>

      {/* Tagline */}
      <p className="hero-tagline hero-anim hero-anim--2">
        {t.hero.tagline}
      </p>

      {/* Divider */}
      <div className="hero-divider hero-anim hero-anim--3" />

      {/* Social links */}
      <ul className="hero-social-links hero-anim hero-anim--4">
        <li>
          <a href="https://www.facebook.com/hoope1998" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <FontAwesomeIcon icon={faFacebook} />
          </a>
        </li>
        <li>
          <a href="https://www.instagram.com/abdalwahabhussien" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <FontAwesomeIcon icon={faInstagram} />
          </a>
        </li>
        <li>
          <a href="https://www.linkedin.com/in/alfaghiri/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <FontAwesomeIcon icon={faLinkedin} />
          </a>
        </li>
        <li>
          <a href="https://github.com/Alfaghiri" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
            <FontAwesomeIcon icon={faGithub} />
          </a>
        </li>
      </ul>

      {/* Scroll-down arrow */}
      <button className="hero-scroll-arrow hero-anim hero-anim--5" onClick={scrollDown} aria-label="Scroll down">
        <FontAwesomeIcon icon={faChevronDown} />
      </button>

    </section>
  );
};

export default Social;
